// Fix for ResizeObserver loop error
export const fixResizeObserverError = () => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') return;

  // Debounce function to limit the frequency of ResizeObserver callbacks
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Store the original ResizeObserver
  const _ResizeObserver = window.ResizeObserver;

  // Create a new ResizeObserver that debounces the callback
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      // Debounce the callback to prevent rapid successive calls
      const debouncedCallback = debounce(callback, 16);
      super(debouncedCallback);
    }
  };

  // Add error handler for unhandled promise rejections
  window.addEventListener('error', (event) => {
    if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.stopImmediatePropagation();
      return false;
    }
  });

  // Add error handler for unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
      return false;
    }
  });
};

// Apply the fix immediately
fixResizeObserverError(); 